import styled from '@emotion/styled';
import { memo, useEffect, useRef, useState } from 'react';

interface BrandLogoProps {
	logoUrl?: string;
}

const BrandDiv = styled.div<{ showLogo?: boolean }>`
	margin: 0px 0px 0px 0.5rem;
	text-decoration: none;
	color: var(--bs-white);
	align-items: center;
	flex-direction: column;
	justify-content: center;

	> img {
		max-height: 2rem;
		max-width: 140px;
		border-radius: 0.25rem;
		width: auto;
		height: auto;
	}
`;

// Use memoization to only rerender when props change
// => https://www.debugbear.com/blog/react-rerenders
const BrandLogo = memo<BrandLogoProps>(({ logoUrl }) => {
	const [src, setSrc] = useState(logoUrl || '');
	const triedLower = useRef(false);

	useEffect(() => {
		setSrc(logoUrl || '');
		triedLower.current = false;
	}, [logoUrl]);

	const handleError = () => {
		if (!triedLower.current && logoUrl && logoUrl !== logoUrl.toLowerCase()) {
			setSrc(logoUrl.toLowerCase());
			triedLower.current = true;
		}
	};

	return (
		<BrandDiv
			className="bay-brand-image"
			showLogo={logoUrl && logoUrl?.length > 0}
		>
			<img
				alt="logo"
				className="bay-image"
				id="bay_nav_logo"
				src={src ? `${src}?t=${Date.now()}` : ''}
				onError={handleError}
			/>
		</BrandDiv>
	);
});

export default BrandLogo;
